type BrandLogoSize = 'sm' | 'md' | 'lg';

interface BrandLogoProps {
  size?: BrandLogoSize;
  className?: string;
  alt?: string;
  onClick?: () => void;
}

// Horizontal seal + wordmark lockup (~2.5:1), single brand red; reads on both light and dark surfaces.
const sizeClassBySize: Record<BrandLogoSize, string> = {
  sm: 'h-10',
  md: 'h-12',
  lg: 'h-14',
};

export default function BrandLogo({
  onClick,
  size = 'md',
  className = '',
  alt = 'Georgian Tea Portal logo',
}: BrandLogoProps) {
  const classes = `${sizeClassBySize[size]} w-auto shrink-0 object-contain ${className}`.trim();
  const logoUrl = withPathPrefix('/assets/branding/Logo-GTP-new.svg');

  return (
    <img
      src={logoUrl}
      alt={alt}
      // Intrinsic size of Logo-GTP-new.svg (viewBox 1177x473): reserves the ~2.5:1 box before the
      // SVG loads so the header does not reflow (CLS). CSS height + w-auto still set the rendered size.
      width={1177}
      height={473}
      className={classes}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    />
  );
}
import { withPathPrefix } from '../../../website/pathPrefix';
